import { loadBaggageAllowance } from './services'

const getDefaultState = () => {
  return {
    baggage: null,
  }
}

const state = getDefaultState()

const getters = {
  getBaggage: (state) => {
    return state.baggage ? state.baggage : null
  },
}

const actions = {
  async loadBaggageAction({ commit, rootState }) {
    const booking = rootState.booking.booking
    if (
      !booking ||
      !booking.booking_itinerary ||
      !booking.booking_itinerary.itinerary
    ) {
      return commit('baggageReceived', null)
    }
    const handBaggageItems = []
    const checkedBaggageItems = []
    const itineraryItems = booking.booking_itinerary.itinerary
    const baggageItems = {
      hand: [],
      checked: [],
    }
    let dupeHandObj = {}
    let dupeCheckedObj = {}
    for (let i = 0; i < itineraryItems.length; i++) {
      if (itineraryItems[i].baggage) {
        for (let b = 0; b < itineraryItems[i].baggage.length; b++) {
          // eslint-disable-next-line no-await-in-loop
          const baggage = { ...itineraryItems[i].baggage[b] }
          baggage.bookingname = booking.booking_information.lead_surname
          baggage.bookingnumber = booking.user_information.bookingNumber
          baggage.departure = itineraryItems[i].date
          const resChecked = await loadBaggageAllowance(baggage)
          let resHand = null
          for (
            let h = 0;
            h < itineraryItems[i].baggage[b].flights.length;
            h++
          ) {
            resHand = await loadBaggageAllowance({
              hand: true,
              single: true,
              departure: itineraryItems[i].date,
              flights: [
                {
                  ...itineraryItems[i].baggage[b].flights[h],
                },
              ],
              bookingname: booking.booking_information.lead_surname,
              bookingnumber: booking.user_information.bookingNumber,
            })
            const tmp = {
              flights: [itineraryItems[i].baggage[b].flights[h]],
              itineraryItem: itineraryItems[i],
              baggageItem:
                resChecked && resChecked.Cabin ? resChecked.Cabin : null,
              galLocator: baggage.galLocator,
            }
            checkedBaggageItems.push(tmp)

            handBaggageItems.push({
              itineraryItem: itineraryItems[i],
              flights: itineraryItems[i].baggage[b].flights[h],
              baggageItem: resHand && resHand.Hand ? resHand.Hand : null,
              galLocator: baggage.galLocator,
            })
          }
          // Hand: resHand && resHand.Hand ? resHand.Hand : null
        }
      }
    }
    baggageItems.hand = handBaggageItems
    baggageItems.checked = checkedBaggageItems
    return commit('baggageReceived', baggageItems)
  },
  resetStateAction({ commit }) {
    commit('resetState')
  },
}

const mutations = {
  baggageReceived(state, baggage) {
    state.baggage = baggage
  },
  resetState(state) {
    Object.assign(state, getDefaultState())
  },
}

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
}
